// extracted by mini-css-extract-plugin
export default {"wrapper":"Qz","noPadding":"Rz","flavor_wrapper":"Sz","flavor_button":"Tz","vert":"Uz","itemContent":"Vz","itemName":"Wz","blue":"Xz","out_of_stock":"Yz","newFlavorBadge":"Zz","fullWidth":"aA","flavor_button_selected":"bA","black":"cA","attribute_wrapper":"eA","toggle_wrapper":"fA"};
    if(module.hot) {
      // 1713969933222
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  